// views.app.onboarding

export const ONBOARDING = {};
